import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-polyglot'
import { getConditionFleetList, getConditionFleetListSuccess, closeConditionsFleetComponent } from '../../../../actions/management/management'
import { openConditionDetailsFleetModal } from '../../../../actions/management/auxModals/auxModals'
import { openModal } from '../../../../actions/common'
import ConditionsListComponent from '../../../../components/management/fleets/conditions/ConditionsListComponent'
import TrackingContainer from '../../../tracking/trackingContainer'

export function mapStateToProps (state) {
  return {
    ...state.management.conditionsFleetComponent
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      openModal,
      getConditionFleetList,
      getConditionFleetListSuccess,
      closeConditionsFleetComponent,
      openConditionDetailsFleetModal
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(TrackingContainer(ConditionsListComponent, true)))
